'use client';

import { usePathname } from 'next/navigation';
import Image from 'next/image';
import { CheckCircle } from '@phosphor-icons/react';

export default function MobileBlock({ force = false }: { force?: boolean }) {
  const pathname = usePathname();

  const isAllowed = () => {
    if (force) return false;
    if (pathname === '/login') return true;
    if (pathname === '/signup') return true;
    if (pathname === '/onboarding') return true;
    return false;
  };

  if (isAllowed()) return null;

  return (
    <div className="fixed inset-0 z-[9999] flex flex-col items-center justify-center bg-primitive-white-off-white px-6 lg:hidden">
      {/* Header */}
      <div className="absolute left-4 top-4">
        <Image
          src="/assets/onboarding/Entelligence.svg"
          alt="Entelligence"
          width={140}
          height={28}
        />
      </div>

      <div className="flex flex-col items-center gap-8 text-center">
        {/* Desktop illustration */}
        <div className="relative w-[55vw] max-w-[240px] aspect-square">
          <Image
            src="/assets/ellie-tv.svg"
            alt="Desktop"
            fill
            sizes="(max-width: 768px) 55vw, 240px"
            className="object-contain"
          />
        </div>

        {/* Text */}
        <div className="flex flex-col gap-2">
          <h1
            className="text-3xl text-ds-text-darker"
            style={{ fontFamily: 'serif', letterSpacing: '0.02em' }}
          >
            Entelligence works best
            <br />
            on desktop!
          </h1>
          <p className="text-sm font-medium text-ds-text-subtle">
            Complex insights need room to breathe.
          </p>
        </div>

        {/* Feature list */}
        <div className="flex flex-wrap items-center justify-center gap-3">
          {[
            'Code Reviews',
            'Team Performance Insights',
            'CLI based review',
            'Ask Ellie',
          ].map((feature) => (
            <div key={feature} className="flex items-center gap-1.5">
              <CheckCircle
                size={18}
                weight="fill"
                className="shrink-0 text-ds-brand-default"
              />
              <span className="text-sm font-medium text-ds-brand-default">
                {feature}
              </span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
